interface Props {
  children: string | number;
  stripSuffix?: boolean;
}

export default function Units(props: Props) {
  const { children: units = 0 } = props;

  return (
    <>
      {Number(units)}
      {props.stripSuffix ? "" : " units"}
    </>
  );
}
